import React from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

const TableHeader = ({ title, addlink }) => {
  return (
    <div className="doctor-table-blk">
      <h3>{title}</h3>
      <div className="doctor-search-blk">
        <div className="top-nav-search table-search-blk">
          <form>
            <input
              type="text"
              className="form-control"
              placeholder="Search here"
            />
            <button className="btn" type="submit">
              <FeatherIcon icon="search" size={16} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TableHeader;